/**
 * Currency types and options used in the application.
 * LCU - Local Currency Unit
 * USD - US Dollar
 */
export const CURRENCY_OPTIONS = ['LCU', 'USD'] as const;
export type TCurrency = (typeof CURRENCY_OPTIONS)[number];

/**
 * Default currency used in the application.
 */
export const DEFAULT_CURRENCY: TCurrency = 'LCU';
